import { render } from "./CookieConsentBanner.vue?vue&type=template&id=f8b40c4c&scoped=true"
import script from "./CookieConsentBanner.vue?vue&type=script&lang=js"
export * from "./CookieConsentBanner.vue?vue&type=script&lang=js"

import "./CookieConsentBanner.vue?vue&type=style&index=0&id=f8b40c4c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b40c4c"]])

export default __exports__